bovoApp.
  factory('Allocation', ['$http', function ($http) {
    return {
      all: function () {
        return $http.get('api/allocations');
      },
      get: function (id) {
        return $http.get('api/allocation/' + id);
      },
      new: function (id) {
        return $http.get('api/new-allocation');
      },
      delete: function (id) {
        return $http.delete('api/delete-allocation/' + id);
      },
      save: function (data) {
        return $http.post('api/save-allocation', data);
      },
      saveQuota: function (data) {
        return $http.post('api/save-allocation-quota', data);
      },
      update: function (data) {
        return $http.post('api/update-allocation', data);
      },
      getTables: function (data) {
        return $http.post('api/allocation-tables', data);
      },
      // Suggestions
      getSuggestions: function (allocationId) {
        return $http.get('api/allocation/' + allocationId + '/suggestions');
      },
      generateSuggestions: function (allocationId) {
        return $http.post('api/allocation/' + allocationId + '/generate-suggestions');
      },
      applySuggestion: function (data) {
        return $http.post('api/allocation-suggestion/apply', data);
      },
      rejectSuggestion: function (data) {
        return $http.post('api/allocation-suggestion/reject', data);
      },
      batchProcessSuggestions: function (data) {
        return $http.post('api/allocation-suggestions/batch', data);
      },
      // Rules
      getRules: function (allocationId) {
        return $http.get('api/allocation/' + allocationId + '/rules');
      },
      saveRule: function (data) {
        return $http.post('api/allocation-rule/save', data);
      },
      deleteRule: function (id) {
        return $http.delete('api/allocation-rule/' + id);
      },
      // Blacklist
      getCitiesDistricts: function (allocationId) {
        return $http.get('api/allocation/' + allocationId + '/cities-districts');
      },
      getBlacklist: function (allocationId) {
        return $http.get('api/allocation/' + allocationId + '/blacklist');
      },
      saveBlacklist: function (data) {
        return $http.post('api/allocation-blacklist/save', data);
      },
      deleteBlacklist: function (id) {
        return $http.delete('api/allocation-blacklist/' + id);
      },
      // Suggestions
      exportSuggestions: function (allocationId) {
        return $http.get('api/allocation/' + allocationId + '/suggestions/export');
      },
      // Export
      exportAllocation: function (allocationId) {
        return $http.get('api/allocation/' + allocationId + '/export');
      },
      // Rows Management
      saveRows: function (allocationId, rows) {
        return $http.post('api/allocation/' + allocationId + '/rows', { rows: rows });
      },
      deleteRow: function (allocationId, rowId) {
        return $http.delete('api/allocation/' + allocationId + '/row/' + rowId);
      },
      deleteRows: function (allocationId, rowIds) {
        return $http.post('api/allocation/' + allocationId + '/rows/delete', { row_ids: rowIds });
      },
    };
  }]);